<template>
    <div class="page">
        <van-nav-bar
                title="私家团报价"
                left-text="返回"
                left-arrow
                fixed
                placeholder
                @click-left="onClickLeft"
        />
        <div class="content-box">
            <!-- 自定义Tab栏 -->
            <div class="custom-tabs">
                <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">标准模式</div>
                <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">定制模式</div>
                <div class="tab-line" :style="{ left: activeTab === 0 ? 'calc(25% - 20px)' : 'calc(75% - 20px)' }" />
            </div>

            <!-- 标准模式页面 -->
            <div class="tab-content" v-show="activeTab === 0">
                <div class="date-section">
                    <van-field
                            v-model="standardForm.departureDate"
                            label="出发日期"
                            placeholder="请选择出发日期"
                            readonly
                            is-link
                            required
                            @click="standardForm.showDatePicker = true"
                    />
                    <van-popup v-model="standardForm.showDatePicker" position="bottom">
                        <van-datetime-picker
                                v-model="standardForm.currentDate"
                                type="date"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="onStandardDateConfirm"
                                @cancel="standardForm.showDatePicker = false"
                        />
                    </van-popup>
                </div>
                <div class="input-section">
                    <van-field v-model.number="standardForm.adultCount" label="成人数量" type="digit" placeholder="请输入" required />
                    <van-field v-model.number="standardForm.childCount" label="儿童数量" type="digit" placeholder="请输入" required />
                </div>
                <div class="btn-section">
                    <van-button type="primary" block round :loading="quoting" @click="onStandardQuote">获取报价</van-button>
                </div>
                <!-- 标准模式报价展示：成人价/儿童价/单房差 -->
                <div class="quote-section" v-if="standardQuoteInfo">
                    <div class="quote-card">
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">成人价</span>
                                <span class="price">¥{{ standardQuoteInfo.adultPrice }}</span>
                            </div>
                            <div class="quote-sub">
                                <span class="profit">利润 ¥{{ standardQuoteInfo.adultProfit }}</span>
                                <span class="cost">成本 ¥{{ standardQuoteInfo.adultCost }}</span>
                                <span class="base">底价 ¥{{ standardQuoteInfo.adultBasePrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">儿童价</span>
                                <span class="price">¥{{ standardQuoteInfo.childPrice }}</span>
                            </div>
                            <div class="quote-sub">
                                <span class="profit">利润 ¥{{ standardQuoteInfo.childProfit }}</span>
                                <span class="cost">成本 ¥{{ standardQuoteInfo.childCost }}</span>
                                <span class="base">底价 ¥{{ standardQuoteInfo.childBasePrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">单房差</span>
                                <span class="price">¥{{ standardQuoteInfo.singleRoomDiff }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 标准模式成本详情卡片 -->
                <div class="cost-section" v-if="standardQuoteInfo && standardQuoteInfo.costDetail">
                    <div class="cost-card">
                        <!-- 车费信息 -->
                        <div class="cost-module" v-if="standardQuoteInfo.costDetail.carCost">
                            <div class="module-title">车费信息</div>
                            <div class="cost-row">
                                <span class="cost-label">车辆类型</span>
                                <span class="cost-value">{{ standardQuoteInfo.costDetail.carCost.carTypeName }}</span>
                            </div>
                            <div class="cost-row">
                                <span class="cost-label">单日价格</span>
                                <span class="cost-value">¥{{ standardQuoteInfo.costDetail.carCost.dayPrice }}</span>
                            </div>
                            <div class="cost-row">
                                <span class="cost-label">用车天数</span>
                                <span class="cost-value">{{ standardQuoteInfo.costDetail.carCost.dayCount }} 天</span>
                            </div>
                            <div class="cost-row total-row">
                                <span class="cost-label">用车总价</span>
                                <span class="cost-value cost-highlight">¥{{ standardQuoteInfo.costDetail.carCost.totalPrice }}</span>
                            </div>
                        </div>

                        <!-- 酒店信息 -->
                        <div class="cost-module" v-if="standardQuoteInfo.costDetail.hotelDays && standardQuoteInfo.costDetail.hotelDays.length">
                            <div class="module-title">酒店信息</div>
                            <div class="hotel-item" v-for="(hd, idx) in standardQuoteInfo.costDetail.hotelDays" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">酒店名称</span>
                                    <span class="cost-value">{{ hd.hotelName || '-' }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">入住日期</span>
                                    <span class="cost-value">{{ hd.checkInDate }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">房间类型</span>
                                    <span class="cost-value">{{ hd.roomTypeName }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">房间数量</span>
                                    <span class="cost-value">{{ hd.roomCount }} 间</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">单日价格</span>
                                    <span class="cost-value">¥{{ hd.dayPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">酒店总费用</span>
                                <span class="cost-value cost-highlight">¥{{ standardQuoteInfo.costDetail.totalHotelCost }}</span>
                            </div>
                        </div>

                        <!-- 门票信息 -->
                        <div class="cost-module" v-if="standardQuoteInfo.costDetail.tickets && standardQuoteInfo.costDetail.tickets.length">
                            <div class="module-title">门票信息</div>
                            <div class="ticket-item" v-for="(t, idx) in standardQuoteInfo.costDetail.tickets" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">{{ t.attractionName }}</span>
                                    <span class="cost-value">¥{{ t.ticketPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">门票总费用</span>
                                <span class="cost-value cost-highlight">¥{{ calcTicketTotalCost }}</span>
                            </div>
                        </div>

                        <!-- 赠送项目 -->
                        <div class="cost-module" v-if="standardQuoteInfo.costDetail.gifts && standardQuoteInfo.costDetail.gifts.length">
                            <div class="module-title">赠送项目</div>
                            <div class="gift-item" v-for="(g, idx) in standardQuoteInfo.costDetail.gifts" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">{{ g.giftName }}</span>
                                    <span class="cost-value">¥{{ g.costPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">赠送项目总成本</span>
                                <span class="cost-value cost-highlight">¥{{ standardQuoteInfo.costDetail.totalGiftCost }}</span>
                            </div>
                        </div>

                        <!-- 总成本 -->
                        <div class="cost-row grand-total">
                            <span class="cost-label">总成本</span>
                            <span class="cost-value cost-highlight">¥{{ standardQuoteInfo.costDetail.totalCost }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 定制模式页面 -->
            <div class="tab-content" v-show="activeTab === 1">
                <div class="date-section">
                    <van-field
                            v-model="customForm.departureDate"
                            label="出发日期"
                            placeholder="请选择出发日期"
                            readonly
                            is-link
                            required
                            @click="customForm.showDatePicker = true"
                    />
                    <van-popup v-model="customForm.showDatePicker" position="bottom">
                        <van-datetime-picker
                                v-model="customForm.currentDate"
                                type="date"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="onCustomDateConfirm"
                                @cancel="customForm.showDatePicker = false"
                        />
                    </van-popup>
                </div>
                <div class="input-section">
                    <van-field v-model.number="customForm.adultCount" label="成人数量" type="digit" placeholder="请输入" required />
                    <van-field v-model.number="customForm.childCount" label="儿童数量" type="digit" placeholder="请输入" required />
                    <van-field v-model.number="customForm.twinRoomCount" label="标间数量" type="digit" placeholder="自动计算" />
                    <van-field v-model.number="customForm.doubleRoomCount" label="大床房数量" type="digit" placeholder="0" />
                    <van-field v-model.number="customForm.tripleRoomCount" label="三人间数量" type="digit" placeholder="0" />
                    <van-field v-model="customForm.carType" label="车型" placeholder="请选择车型" readonly is-link @click="customForm.showCarPicker = true" />
                    <van-popup v-model="customForm.showCarPicker" position="bottom">
                        <van-picker
                                :columns="carTypeList"
                                show-toolbar
                                title="选择车型"
                                @confirm="onCarTypeConfirm"
                                @cancel="customForm.showCarPicker = false"
                        />
                    </van-popup>
                </div>
                <div class="btn-section">
                    <van-button type="primary" block round :loading="customQuoting" @click="onCustomQuote">获取报价</van-button>
                </div>
                <!-- 定制模式报价展示：总价(含利润成本底价)/平均单人价格 -->
                <div class="quote-section" v-if="customQuoteInfo">
                    <div class="quote-card">
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">总价</span>
                                <span class="price">¥{{ customQuoteInfo.totalPrice }}</span>
                            </div>
                            <div class="quote-sub">
                                <span class="profit">利润 ¥{{ customQuoteInfo.profit }}</span>
                                <span class="cost">成本 ¥{{ customQuoteInfo.cost }}</span>
                                <span class="base">底价 ¥{{ customQuoteInfo.basePrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">成人价</span>
                                <span class="price">¥{{ customQuoteInfo.adultPrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">儿童价</span>
                                <span class="price">¥{{ customQuoteInfo.childPrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">住宿总价</span>
                                <span class="price">¥{{ customQuoteInfo.totalHotelPrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">用车总价</span>
                                <span class="price">¥{{ customQuoteInfo.totalCarPrice }}</span>
                            </div>
                        </div>
                        <div class="quote-item">
                            <div class="quote-main">
                                <span class="label">门票单人价格</span>
                                <span class="price">¥{{ customQuoteInfo.ticketPricePerPerson }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 定制模式成本详情卡片 -->
                <div class="cost-section" v-if="customQuoteInfo && customQuoteInfo.costDetail">
                    <div class="cost-card">
                        <!-- 车费信息 -->
                        <div class="cost-module" v-if="customQuoteInfo.costDetail.carCost">
                            <div class="module-title">车费信息</div>
                            <div class="cost-row">
                                <span class="cost-label">车辆类型</span>
                                <span class="cost-value">{{ customQuoteInfo.costDetail.carCost.carTypeName }}</span>
                            </div>
                            <div class="cost-row">
                                <span class="cost-label">单日价格</span>
                                <span class="cost-value">¥{{ customQuoteInfo.costDetail.carCost.dayPrice }}</span>
                            </div>
                            <div class="cost-row">
                                <span class="cost-label">用车天数</span>
                                <span class="cost-value">{{ customQuoteInfo.costDetail.carCost.dayCount }} 天</span>
                            </div>
                            <div class="cost-row total-row">
                                <span class="cost-label">用车总价</span>
                                <span class="cost-value cost-highlight">¥{{ customQuoteInfo.costDetail.carCost.totalPrice }}</span>
                            </div>
                        </div>

                        <!-- 酒店信息 -->
                        <div class="cost-module" v-if="customQuoteInfo.costDetail.hotelDays && customQuoteInfo.costDetail.hotelDays.length">
                            <div class="module-title">酒店信息</div>
                            <div class="hotel-item" v-for="(hd, idx) in customQuoteInfo.costDetail.hotelDays" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">酒店名称</span>
                                    <span class="cost-value">{{ hd.hotelName || '-' }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">入住日期</span>
                                    <span class="cost-value">{{ hd.checkInDate }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">房间类型</span>
                                    <span class="cost-value">{{ hd.roomTypeName }}</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">房间数量</span>
                                    <span class="cost-value">{{ hd.roomCount }} 间</span>
                                </div>
                                <div class="cost-row">
                                    <span class="cost-label">单日价格</span>
                                    <span class="cost-value">¥{{ hd.dayPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">酒店总费用</span>
                                <span class="cost-value cost-highlight">¥{{ customQuoteInfo.costDetail.totalHotelCost }}</span>
                            </div>
                        </div>

                        <!-- 门票信息 -->
                        <div class="cost-module" v-if="customQuoteInfo.costDetail.tickets && customQuoteInfo.costDetail.tickets.length">
                            <div class="module-title">门票信息</div>
                            <div class="ticket-item" v-for="(t, idx) in customQuoteInfo.costDetail.tickets" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">{{ t.attractionName }}</span>
                                    <span class="cost-value">¥{{ t.ticketPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">门票总费用</span>
                                <span class="cost-value cost-highlight">¥{{ calcCustomTicketTotalCost }}</span>
                            </div>
                        </div>

                        <!-- 赠送项目 -->
                        <div class="cost-module" v-if="customQuoteInfo.costDetail.gifts && customQuoteInfo.costDetail.gifts.length">
                            <div class="module-title">赠送项目</div>
                            <div class="gift-item" v-for="(g, idx) in customQuoteInfo.costDetail.gifts" :key="idx">
                                <div class="cost-row">
                                    <span class="cost-label">{{ g.giftName }}</span>
                                    <span class="cost-value">¥{{ g.costPrice }}</span>
                                </div>
                            </div>
                            <div class="cost-row total-row module-total">
                                <span class="cost-label">赠送项目总成本</span>
                                <span class="cost-value cost-highlight">¥{{ customQuoteInfo.costDetail.totalGiftCost }}</span>
                            </div>
                        </div>

                        <!-- 总成本 -->
                        <div class="cost-row grand-total">
                            <span class="cost-label">总成本</span>
                            <span class="cost-value cost-highlight">¥{{ customQuoteInfo.costDetail.totalCost }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {NavBar, Field, Popup, DatetimePicker, Button, Picker} from 'vant';
    import {akPrivateTourQuote, akPrivateTourCustomQuote} from '@/api/privateTour';

    export default {
        name: "privateTourDetail",
        components: {
            [NavBar.name]: NavBar,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [Button.name]: Button,
            [Picker.name]: Picker
        },
        data() {
            return {
                productId: null,
                activeTab: 0,
                minDate: new Date(),
                maxDate: new Date(new Date().getFullYear() + 1, 11, 31),
                carTypeList: ['五座舒适', '五座豪华', '七座舒适', '七座豪华', '九座舒适', '九座豪华'],
                standardForm: {
                    departureDate: '',
                    adultCount: null,
                    childCount: null,
                    showDatePicker: false,
                    currentDate: new Date()
                },
                quoting: false,
                customQuoting: false,
                customForm: {
                    departureDate: '',
                    adultCount: null,
                    childCount: null,
                    twinRoomCount: null,
                    doubleRoomCount: 0,
                    tripleRoomCount: 0,
                    carType: '',
                    carTypeId: null,
                    showDatePicker: false,
                    showCarPicker: false,
                    currentDate: new Date()
               },
                standardQuoteInfo: null,
                customQuoteInfo: null
            };
        },
        watch: {
            'customForm.adultCount'(val) {
                if (val && val > 0) {
                    this.customForm.twinRoomCount = Math.ceil(val / 2)
                } else {
                    this.customForm.twinRoomCount = null
                }
            }
        },
        computed: {
            calcTicketTotalCost() {
                const tickets = (this.standardQuoteInfo && this.standardQuoteInfo.costDetail && this.standardQuoteInfo.costDetail.tickets) || []
                return tickets.reduce((sum, t) => {
                    return sum + (parseFloat(t.ticketPrice) || 0)
                }, 0)
            },
            calcCustomTicketTotalCost() {
                const tickets = (this.customQuoteInfo && this.customQuoteInfo.costDetail && this.customQuoteInfo.costDetail.tickets) || []
                return tickets.reduce((sum, t) => {
                    return sum + (parseFloat(t.ticketPrice) || 0)
                }, 0)
            }
        },
        created() {
            this.productId = this.$route.query.id
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1)
            },
            onStandardDateConfirm(value) {
                this.standardForm.departureDate = this.formatDate(value)
                this.standardForm.currentDate = value
                this.standardForm.showDatePicker = false
            },
            onCustomDateConfirm(value) {
                this.customForm.departureDate = this.formatDate(value)
                this.customForm.currentDate = value
                this.customForm.showDatePicker = false
            },
            onCarTypeConfirm(value) {
                this.customForm.carType = value.text || value
                // 车型ID映射：五座舒适=17, 五座豪华=18, 七座舒适=25, 七座豪华=19, 九座舒适=20, 九座豪华=24
                const carTypeMap = {'五座舒适': 17, '五座豪华': 18, '七座舒适': 25, '七座豪华': 19, '九座舒适': 20, '九座豪华': 24}
                this.customForm.carTypeId = carTypeMap[this.customForm.carType] || null
                this.customForm.showCarPicker = false
            },
            formatDate(value) {
                const year = value.getFullYear()
                const month = String(value.getMonth() + 1).padStart(2, '0')
                const day = String(value.getDate()).padStart(2, '0')
                return `${year}-${month}-${day}`
            },
            validateQuoteData(adultCount, childCount) {
                // 不能为空
                if (adultCount === null || adultCount === undefined || adultCount === '') {
                    this.$toast('请输入成人数量')
                    return false
                }
                if (childCount === null || childCount === undefined || childCount === '') {
                    this.$toast('请输入儿童数量')
                    return false
                }
                adultCount = Number(adultCount)
                childCount = Number(childCount)
                if (adultCount < 0 || childCount < 0) {
                    this.$toast('人数不能为负数')
                    return false
                }
                // 成人数量不能为0
                if (adultCount === 0) {
                    this.$toast('成人数量不能为0')
                    return false
                }
                // 总和不超过8
                if (adultCount + childCount > 8) {
                    this.$toast('成人数量和儿童数量之和不能超过8人')
                    return false
                }
                // 儿童数量不能大于成人数量+2
                if (childCount > adultCount + 2) {
                    this.$toast('儿童太多了')
                    return false
                }
                return true
            },
            onStandardQuote() {
                if (!this.standardForm.departureDate) {
                    this.$toast('请先选择出发日期')
                    return
                }
                if (!this.validateQuoteData(this.standardForm.adultCount, this.standardForm.childCount)) {
                    return
                }
                if (!this.productId) {
                    this.$toast('产品ID缺失')
                    return
                }
                this.quoting = true
                this.standardQuoteInfo = null
                akPrivateTourQuote({
                    productId: this.productId,
                    travelDate: this.standardForm.departureDate,
                    adultCount: this.standardForm.adultCount,
                    childCount: this.standardForm.childCount
                }).then(res => {
                    this.standardQuoteInfo = res
                }).catch(err => {
                    // 错误信息已由 request 拦截器 toast 提示
                }).finally(() => {
                    this.quoting = false
                })
            },
            onCustomQuote() {
                if (!this.customForm.departureDate) {
                    this.$toast('请先选择出发日期')
                    return
                }
                if (!this.validateQuoteData(this.customForm.adultCount, this.customForm.childCount)) {
                    return
                }
                if (!this.productId) {
                    this.$toast('产品ID缺失')
                    return
                }
                this.customQuoting = true
                this.customQuoteInfo = null
                // 如果三种房型都未填，不传房型数量，让后端自动按标间计算
                const params = {
                    productId: this.productId,
                    travelDate: this.customForm.departureDate,
                    adultCount: this.customForm.adultCount,
                    childCount: this.customForm.childCount
                }
                // 只有用户手动填了房型数量才传
                if (this.customForm.twinRoomCount != null && this.customForm.twinRoomCount > 0) {
                    params.standardRoomCount = this.customForm.twinRoomCount
                }
                if (this.customForm.doubleRoomCount != null && this.customForm.doubleRoomCount > 0) {
                    params.doubleRoomCount = this.customForm.doubleRoomCount
                }
                if (this.customForm.tripleRoomCount != null && this.customForm.tripleRoomCount > 0) {
                    params.tripleRoomCount = this.customForm.tripleRoomCount
                }
                // 车型ID（不选则不传，后端自动匹配）
                if (this.customForm.carTypeId) {
                    params.carTypeId = this.customForm.carTypeId
                }
                akPrivateTourCustomQuote(params).then(res => {
                    this.customQuoteInfo = res
                }).catch(err => {
                    // 错误信息已由 request 拦截器 toast 提示
                }).finally(() => {
                    this.customQuoting = false
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        min-height: 100vh;
        background: #f5f7fa;
    }

    .content-box {
        padding: 0 16px;
        padding-bottom: 20px;
    }

    .custom-tabs {
        display: flex;
        position: relative;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-top: 12px;
        margin-bottom: 12px;

        .tab-item {
            flex: 1;
            text-align: center;
            padding: 14px 0;
            font-size: 15px;
            color: #666;
            cursor: pointer;
            transition: color 0.3s;

            &.active {
                color: #333;
                font-weight: bold;
            }
        }

        .tab-line {
            position: absolute;
            bottom: 0;
            width: 40px;
            height: 3px;
            background: #ff6b35;
            border-radius: 2px;
            transition: left 0.3s ease;
        }
    }

    .date-section {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 16px;
    }

    .input-section {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 16px;
    }

    .btn-section {
        margin-bottom: 20px;
    }

    .quote-section {
        .quote-card {
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            padding: 12px 16px;
        }

        .quote-item {
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }

            &:first-child {
                padding-top: 0;
            }
        }

        .quote-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 6px;

            .label {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .price {
                font-size: 18px;
                font-weight: bold;
                color: #ff6b35;
            }
        }

        .quote-sub {
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .profit {
                font-size: 12px;
                color: #409EFF;
            }

            .cost {
                font-size: 12px;
                color: #999;
            }

            .base {
                font-size: 12px;
                color: #67c23a;
            }
        }
    }

    /* 成本详情卡片 */
    .cost-section {
        margin-top: 20px;

        .cost-card {
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            padding: 12px 16px;
        }

        .cost-module {
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
                border-bottom: none;
            }

            .module-title {
                font-size: 15px;
                font-weight: bold;
                color: #333;
                margin-bottom: 10px;
            }

            .hotel-item, .ticket-item, .gift-item {
                background: #f7f8fa;
                border-radius: 8px;
                padding: 8px 12px;
                margin-bottom: 8px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .ticket-item {
                .cost-row {
                    padding: 4px 0;
                }
            }
        }

        .cost-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6px 0;
            font-size: 14px;

            .cost-label {
                color: #666;
            }

            .cost-value {
                color: #333;
                font-weight: 500;
            }

            &.total-row {
                margin-top: 6px;
                padding-top: 8px;
                border-top: 1px dashed #e0e0e0;
            }

            &.module-total {
                padding-top: 10px;
            }

            .cost-highlight {
                color: #ff6b35;
                font-weight: bold;
                font-size: 15px;
            }
        }

        .grand-total {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 2px solid #ff6b35;
            font-size: 16px;

            .cost-label {
                font-weight: bold;
                color: #333;
            }

            .cost-value {
                font-size: 18px;
                font-weight: bold;
                color: #ff6b35;
            }
        }
    }
</style>
